





































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import ListUtils from '@/lib/listUtils';
import { SpecOutDetailsModule } from '@/store/modules/specOutDetails';

@Component({
    name: 'SpecOutBrowseContactsSearchCriteria'
})
export default class extends GiganautVueDialog {

  public dialog = false;

  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      if (AgencySettingsModule.positions.length === 0) {
        await AgencySettingsModule.getPositions();
      }
      if (AgencySettingsModule.locationTypes.length === 0) {
        await AgencySettingsModule.getLocationTypes();
      }
    }
  }

  get specOut() {
    return SpecOutDetailsModule.currentSpecOut;
  }

  get searchVM() {
    return SpecOutDetailsModule.contactSearchViewModel;
  }

  get showDistanceFilter() {
    return this.specOut.worker != null;
  }

  get distanceOptions() {
    return ListUtils.distanceOptions();
  }

  get statusOptions() {
    return ListUtils.contactStatuses();
  }

  get positions() {
    return AgencySettingsModule.positions;
  }

  get locationTypes() {
    return AgencySettingsModule.locationTypes;
  }

  get loading() {
    return SpecOutDetailsModule.loadingContacts;
  }

  async search() {
    this.dialog = false;
    await SpecOutDetailsModule.browseContactSearch();
  }
}
